module.exports = __webpack_public_path__ + "static/img/big4.bbe1ec5.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/big4.png
// module id = UCY7
// module chunks = 1